import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import Slider from "react-slick";
import { all_routes } from "../router/all_routes";
import { ListCarsData, ListMasterData, S3CDNURL, showTitleMaster } from "../../functionsMaster";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";

const RecommendedCars = () => {
    const [carData, setCarData] = useState([]);
        useEffect(() => {
            const fetchData = async () => {
            const temp = await ListCarsData({ status: 1, limit: 6, home: 1 });            
            // Do something with data, like setting it to state
            setCarData(temp.data);
        };
        fetchData();
    }, []);

    async function getAllCars() {
      const temp = await ListCarsData({ status: 1, limit: 6, home: 1 });            
      // Do something with data, like setting it to state
      setCarData(temp.data);
    }
  const routes = all_routes;

    const [carCategory, setCarCategory] = useState([]); // temp
    const [carBrand, setCarBrand] = useState([]); // temp1
    // const [carModel, setCarModel] = useState([]); // temp2
    // const [carColor, setCarColor] = useState([]); // temp3
    const [carSeat, setCarSeat] = useState([]); // temp4
     const [carFuel, setCarFuel] = useState([]); // temp5
    // const [carDoor, setCarDoor] = useState([]); // temp6
    // const [carCylinder, setCylinder] = useState([]); // temp7
    const [carTransmission, setCarTransmission] = useState([]); // temp8
    const [carSteering, setCarSteering] = useState([]); // temp9
    // const [carFeatures, setCarFeatures] = useState([]); // temp10
    // const [carSafetyFeatures, setCarSafetyFeatures] = useState([]); // temp11
  
    // const [branchLocation, setBranchLocation] = useState([]); // temp12
    // const [carsPackages, setCarsPackages] = useState([]); // temp13 
  
  useEffect(() => {
    const CACHE_DURATION = 4 * 60 * 60 * 1000; // 4 hours in milliseconds
  
    const fetchData = async () => {    
      const config = [
        { key: 'carCategory', setter: setCarCategory },
        { key: 'carBrand', setter: setCarBrand },
        // { key: 'carColor', setter: setCarColor },
        { key: 'carSeat', setter: setCarSeat },
        { key: 'carFuel', setter: setCarFuel },
        { key: 'carTransmission', setter: setCarTransmission },
        { key: 'carSteering', setter: setCarSteering },
        // { key: 'carFeatures', setter: setCarFeatures },
      ];
  
      await Promise.all(
        config.map(async ({ key, setter }) => {
          const cacheKey = `masterData_${key}`;
          const cacheRaw = localStorage.getItem(cacheKey);
  
          if (cacheRaw) {
            const { timestamp, data } = JSON.parse(cacheRaw);
            const isExpired = Date.now() - timestamp > CACHE_DURATION;
  
            if (!isExpired && Array.isArray(data)) {
              setter(data);
              return;
            }
          }
  
          // Fetch from API if not cached or expired
          try {
            const res = await ListMasterData(key, { status: 1, limitedData: 'Yes' });
            const data = Array.isArray(res.data) ? res.data : [];
            setter(data);
            if (data && data.length > 0) {
              localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data }));
            }
          } catch (err) {
            console.error(`Failed to fetch ${key}`, err);
            setter([]);
          }
        })
      );
    };
  
    fetchData();
  }, []);

  
  // const rentalslideroption = {
  //   dots: false,
  //   nav: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 1000,
  //       settings: {
  //         slidesToShow: 3,
  //       },
  //     },
  //     {
  //       breakpoint: 700,
  //       settings: {
  //         slidesToShow: 2,
  //       },
  //     },
  //     {
  //       breakpoint: 550,
  //       settings: {
  //         slidesToShow: 1,
  //       },
  //     },
  //     {
  //       breakpoint: 0,
  //       settings: {
  //         slidesToShow: 1,
  //       },
  //     },
  //   ],
  // };

  return (
    
      <section className="section popular-services">
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
            <h2>Recommended Car Rental deals</h2>
            <p>
            Here are some versatile options that cater to different needs
            </p>
          </div>
          {/* /Heading title */}
          <div className="row">
            <div className="popular-slider-group">
              <div className=" rental-deal-slider ">
              {/* <Slider {...rentalslideroption} className="rental-slider"> */}
                {/* owl carousel item */}
                <div className="row">
                  {carData && carData.map((s) => (
                    <div key={s._id} className="col-xxl-4 col-lg-4 col-md-4 col-12">
                      <div className="listing-item">
                        <div className="listing-img">
                          <div className="img-slider listing-page-slider">
                            {/* <Slider {...settings1}></Slider> */}
                              <div className="slide-images">
                                <Link to={`${routes.listingDetails}${s.slug}`}>
                                  <img
                                    src={`${S3CDNURL}${s.image}`}
                                    style={{
                                        height: '220px',
                                        objectFit: 'cover'
                                      }}
                                    className="img-fluid"
                                    alt={s.name}
                                  />
                                </Link>
                              </div>
                          </div>
                          <span className="featured-text">
                            {showTitleMaster(s.brand, carBrand)}
                          </span>
                        </div>
                        <div className="listing-content">
                          <div className="listing-features d-flex align-items-end justify-content-between">
                            <div className="list-rating">
                              <h3 className="listing-title">
                                <Link to={`${routes.listingDetails}${s.slug}`}>
                                  {s.name}
                                </Link>
                              </h3>
                              <div className="list-rating">
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star filled" />
                                <i className="fas fa-star-half filled" />
                                <span>
                                    (4.7)
                                  {/* 138 Reviews */}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="listing-details-group">
                            <ul>
                              <li>
                                <span>
                                  <ImageWithBasePath
                                    src="assets/img/icons/car-parts-01.svg"
                                    alt="Auto"
                                  />
                                </span>
                                <p>{showTitleMaster(s.transmission, carTransmission)}</p>
                              </li>
                              <li>
                                  <span>
                                    <ImageWithBasePath
                                      src="assets/img/icons/car-parts-07.svg"
                                      alt="10 KM"
                                    />
                                  </span>
                                   <p>{showTitleMaster(s.category, carCategory)}</p>
                                </li>
                              <li>
                                <span>
                                  <ImageWithBasePath
                                    src="assets/img/icons/car-parts-03.svg"
                                    alt="Petrol"
                                  />
                                </span>
                                <p>{showTitleMaster(s.fuel, carFuel)}</p>
                              </li>
                            </ul>
                            <ul>
                              <li>
                                <span>
                                  <ImageWithBasePath
                                    src="assets/img/icons/car-parts-04.svg"
                                    alt="Power"
                                  />
                                </span>
                                <p>{showTitleMaster(s.steering, carSteering)}</p>
                              </li>
                              <li>
                                <span>
                                  <ImageWithBasePath
                                    src="assets/img/icons/car-parts-05.svg"
                                    alt='2018'
                                  />
                                </span>
                                <p>{s.year ? s.year : 'NA'}</p>
                              </li>
                              <li>
                                <span>
                                  <ImageWithBasePath
                                    src="assets/img/icons/car-parts-06.svg"
                                    alt="Persons"
                                  />
                                </span>
                                <p>{showTitleMaster(s.seat, carSeat)}</p>
                              </li>
                            </ul>
                          </div>
                          <div className="listing-location-details">
                            <div className="listing-price">
                              <span>
                                <i className="feather icon-map-pin" />
                              </span>
                              Start at
                            </div>
                            <div className="listing-price">
                              <h6>
                                {process.env.REACT_APP_CURRENY_SYMBOL} {s.pricing && s.pricing[0] ? Number(s.pricing[0].baseRate) + ( 12 * Number(s.pricing[0].hourlyRate) ) : ''} <span></span>
                              </h6>
                            </div>
                          </div>
                          <div className="listing-button">
                            <Link
                              to={`${routes.listingDetails}${s.slug}`}
                              className="btn btn-order"
                            >
                              <span>
                                <i className="feather icon-calendar me-2" />
                              </span>
                              Rent Now
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {/* /owl carousel item */}
                {/* </Slider> */}
              </div>
            </div>
          </div>

          {/* View More */}
          <div className="view-all d-none text-center" data-aos="fade-down">
            <Link
              to={routes.listingGrid}
              onClick={(e) => {
                e.preventDefault();
                getAllCars();
              }}
              className="btn btn-view d-inline-flex align-items-center"
            >
              Go to all Cars{" "}
              <span>
                <i className="feather icon-arrow-right ms-2" />
              </span>
            </Link>
          </div>
          {/* View More */}
        </div>
      </section>
  );
};

export default RecommendedCars;
